// extracted by mini-css-extract-plugin
module.exports = {"container":"accessibility-statement_container__Qi0Oy"};